/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import styles from './Contacts.module.css'
import Alert from 'react-bootstrap/Alert';

import { useState } from 'react';
import { database } from '../../firebase'
import { ref, push, child, update } from "firebase/database";
import { useEffect } from 'react';

export default function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [msg, setMsg] = useState('')
  const [isSucess, setisSucess] = useState(false)
  const [isFailed, setisFailed] = useState(false)
  const [isEnabled, setisEnabled] = useState(false)

  const handleSubmit = async () => {
    let obj = {
      name: name,
      email: email,
      subject: subject,
      msg: msg,
    }
    const newPostKey = push(child(ref(database), 'posts')).key;
    const updates = {};
    updates['/' + newPostKey] = obj
    update(ref(database), updates).then(() => {
      // Data saved successfully!
      setisSucess(true)
      setisFailed(false)
    })
      .catch((error) => {
        // The write failed...
        setisFailed(true)
        setisSucess(false)
      });
  }
  useEffect(() => {
    if (name !== '' && email !== '' && subject !== '' && msg !== '') setisEnabled(true)
    else setisEnabled(false)
  },
    [name, email, subject, msg])
  const handleChange = (event) => {
    const fieldName = event.target.name
    const value = event.target.value
    if (fieldName === 'name') setName(value)
    else if (fieldName === 'email') setEmail(value)
    else if (fieldName === 'subject') setSubject(value)
    else if (fieldName === 'msg') setMsg(value)
  }


  return (

    <>
      <div className="row w-100 m-auto my-5 py-5">
        {/* -----------------------------------Left side get In touch------------------------------------- */}
        <div className="col-md-6 mt-5">
          <h4 className="head-line mb-4">Get in Touch</h4>
          <p>
            Hey, hello I am
            <span className="firstColor fs-5 costumedColor"> Muhammed Nabil </span
            >  I would like to welcome you to my website. You are now on the
            contact page. I am pleased to contact you. Here you will find
            all my accounts on all social networking sites, my phone number
            and my email and thanks for getting in touch.
          </p>
          <div className="my-contact ms-4">
            <div className="d-flex align-items-center mb-3">
              <i className="fa-solid fa-envelope fs-5 me-2"></i>
              <a className="text-center fs-6 mailto" href="mailto:mohammednabil1910@gmail.com">
                mohammednabil1910@gmail.com
              </a>
            </div>
            <div className="d-flex align-items-center mb-3">
              <i className="fa-solid fa-location-dot fs-5 me-2"></i>
              <span className="text-center fs-6"
              >Hadayek El-Ahram, El-Haram, Giza</span>
            </div>
            <div className="d-flex align-items-center">
              <i className="fa-solid fa-phone fs-5 me-2"></i>
              <span className="text-center fs-6">01090594627</span>
            </div>
          </div>
          <div className="row ms-auto">
            <div className="SOCIAL mt-3 fs-2 flex-md-nowrap">
              <a href="https://www.facebook.com/modi.nabil.52" target={'_blank'} rel="noreferrer"><i className={`fa-brands ${styles.facebook} fa-facebook mx-3 text-white`}></i></a>
              <a href="https://github.com/MuhammeedNabil?tab=repositories" target={'_blank'} rel="noreferrer"><i className={`fa-brands ${styles.github} fa-github text-white`}></i></a>
              <a href="https://www.linkedin.com/in/m-nabilbkr/" target={'_blank'} rel="noreferrer"><i className={`fa-brands ${styles.linkedin} fa-linkedin text-white  mx-3`}></i></a>
              <a href="https://twitter.com/MohammeedNabil" target={'_blank'} rel="noreferrer"><i className={`fa-brands ${styles.twitter} fa-twitter text-white`}></i></a>
            </div>
          </div>
        </div>
        {/* -----------------------------------Right side contact me------------------------------------- */}
        <div className="col-md-6 mt-5">
          <h4 className="head-line mb-4">Send Me Your Message</h4>
          <form action="" className="text-center" method="post" name="form">
            <input
              id="Contact-Your-Name"
              type="text"
              required
              // defaultValue={name}
              value={name}
              name='name'
              onChange={(e) => handleChange(e)}
              placeholder="Your Name"
              className="form-control ps-2 mb-2 bg-transparent text-white"
            />
            <input
              id="Contact-Your-Email"
              type="email"
              // defaultValue={email}
              value={email}
              name='email'
              onChange={(e) => handleChange(e)}
              required
              placeholder="Your Email"
              className="form-control ps-2 mb-2 bg-transparent text-white"
            />
            <input
              id="Contact-Your-Subject"
              type="text"
              required
              // defaultValue={subject}
              value={subject}
              name='subject'
              onChange={(e) => handleChange(e)}
              placeholder="Subject"
              className="form-control ps-2 mb-2 bg-transparent text-white"
            />
            <textarea
              id="Contact-Your-Message"
              cols="53"
              // defaultValue={msg}
              value={msg}
              name='msg'
              onChange={(e) => handleChange(e)}
              rows="5"
              placeholder="Message"
              className="form-control ps-2 mb-2 bg-transparent text-white"
            ></textarea>
            <button
              id="Contact-send"
              type="button"
              value="Send Email"
              disabled={!isEnabled}
              onClick={() => handleSubmit()}
              className={`btn btn-transparent text-white border rounded ${styles.sendBtn}`}
            >
              Send Message
            </button>
          </form>
        </div>

        {/******************Alerts****************** */}
        {isSucess &&
          <Alert success className="mt-3">
            Thank you, We will get in touch Soon!
          </Alert>
        }
        {isFailed &&

          <Alert danger className="mt-3">
            Opps, An error occured!
          </Alert>
        }
      </div>

    </>

  )
}
